/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiOperation } from '../../asyncapi/models/AaiOperation';
import { AbstractCommand } from '../AbstractCommand';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { Node } from '../../core/models/Node';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';

/**
 * A command used to add an Example for an AsyncAPI 2.0 Message.
 * @author laurent.broudoux@gmail.com
 * @param {AaiOperation} operationNode
 * @param {*} exampleValue
 * @class
 * @extends AbstractCommand
 */
export class AddMessageExampleCommand_Aai20 extends AbstractCommand {
    public _parentPath : NodePath;

    public _newExampleValue : any;

    public _examplesInit : boolean;

    public _exampleAdded : boolean;

    public constructor(operationNode? : any, exampleValue? : any) {
        if(((operationNode != null && operationNode instanceof <any>AaiOperation) || operationNode === null) && ((exampleValue != null) || exampleValue === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._examplesInit===undefined) this._examplesInit = false;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._examplesInit===undefined) this._examplesInit = false;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            (() => {
                this._parentPath = Library.createNodePath(operationNode);
                this._newExampleValue = exampleValue;
            })();
        } else if(operationNode === undefined && exampleValue === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._examplesInit===undefined) this._examplesInit = false;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExampleValue===undefined) this._newExampleValue = null;
            if(this._examplesInit===undefined) this._examplesInit = false;
            if(this._exampleAdded===undefined) this._exampleAdded = false;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddMessageExampleCommand_Aai20] Executing.");
        let operation : AaiOperation = <AaiOperation>this._parentPath.resolve(document);
        this._examplesInit = false;
        this._exampleAdded = false;
        if(this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message)) {
            return;
        }
        let examples : Array<any> = operation.message.examples;
        if(examples == null) {
            examples = <any>([]);
            operation.message.examples = examples;
            this._examplesInit = true;
        }
        if(JsonCompat.isString(this._newExampleValue)) {
            this._newExampleValue = JsonCompat.parseJSON(JsonCompat.toString(this._newExampleValue));
        }
        let newExample : any = <any>({});
        {
            let array161 = JsonCompat.keys(this._newExampleValue);
            for(let index160=0; index160 < array161.length; index160++) {
                let key = array161[index160];
                {
                    /* put */(newExample[key] = JsonCompat.getProperty(this._newExampleValue, key));
                }
            }
        }
        /* add */(examples.push(newExample)>0);
        this._exampleAdded = true;
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddMessageExampleCommand_Aai20] Reverting.");
        let operation : AaiOperation = <AaiOperation>this._parentPath.resolve(document);
        if(!this._exampleAdded || this.isNullOrUndefined(operation) || this.isNullOrUndefined(operation.message)) {
            return;
        }
        let newExample : any = <any>({});
        {
            let array163 = JsonCompat.keys(this._newExampleValue);
            for(let index162=0; index162 < array163.length; index162++) {
                let key = array163[index162];
                {
                    /* put */(newExample[key] = JsonCompat.getProperty(this._newExampleValue, key));
                }
            }
        }
        let elementIndex : number = -1;
        for(let i : number = 0; ((lhs, rhs) => lhs && rhs)(elementIndex === -1, i < /* size */(<number>operation.message.examples.length)); i++) {{
            let example : any = /* get */operation.message.examples[i];
            if(/* size */Object.keys(example).length === /* size */Object.keys(newExample).length) {
                elementIndex = i;
                {
                    let array165 = /* entrySet */(o => { let s = []; for (let e in o) s.push({ k: e, v: o[e], getKey: function() { return this.k }, getValue: function() { return this.v } }); return s; })(example);
                    for(let index164=0; index164 < array165.length; index164++) {
                        let entry = array165[index164];
                        {
                            if(!/* containsKey */newExample.hasOwnProperty(entry.getKey()) || !/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })(JsonCompat.stringify(/* get */((m,k) => m[k]===undefined?null:m[k])(newExample, entry.getKey())),JsonCompat.stringify(entry.getValue())))) {
                                elementIndex = -1;
                                break;
                            }
                        }
                    }
                }
            }
        };}
        if(elementIndex !== -1) {
            /* remove */operation.message.examples.splice(elementIndex, 1)[0];
        }
        if(this._examplesInit && /* isEmpty */(operation.message.examples.length == 0)) {
            operation.message.examples = null;
        }
    }
}
AddMessageExampleCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.AddMessageExampleCommand_Aai20";
AddMessageExampleCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




